//import MoviesList from "./components/MoviesList";
import React, { useEffect } from "react";
import axios from "axios";
import "./App.css";
import MoviesApi from "./components/MoviesApi";
import { Routes, Route } from "react-router-dom";
import MoviesDetails from "./components/MovieDetails.";
import NoMatch from "./components/NoMatch";

function App() {
  const [rating, setRating] = React.useState(1);
  const [pages, setPages] = React.useState(1);
  const [movies, setMovies] = React.useState(null);

  useEffect(() => {
    const getMovies = async () => {
      const response = await axios.get(
        `https://api.themoviedb.org/3/discover/movie?api_key=c5f2c84d63771bd8924b941706200ac1&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&vote_average.gte=${
          rating * 2 - 2
        }&with_watch_monetization_types=flatrate`
      );
      setMovies(response.data.results);
      setPages(1);
    };
    getMovies();
    // eslint-disable-next-line
  }, [rating]);

  return (
    <>
      <div className=" text-white">
        <Routes>
          <Route
            path="/"
            element={
              <MoviesApi
                rating={rating}
                pages={pages}
                setPages={setPages}
                movies={movies}
                setMovies={setMovies}
                setRating={setRating}
              />
            }
          />
          <Route
            path="/peliculas/:id"
            element={
              <MoviesDetails
                movies={movies}
                setMovies={setMovies}
                pages={pages}
              />
            }
          />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
